import { makeAutoObservable } from 'mobx'

class DetailsModalAssignmentStore {
	// Filter state: 'all' | 'completed' | 'pending' | 'not_started'
	activeFilter = 'all'

	// Selected student IDs
	selectedStudentIds = []

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	setActiveFilter(filter) {
		console.log('setActiveFilter', filter)

		this.activeFilter = filter || 'all'
	}

	toggleStudentSelection(studentId) {
		if (!studentId) return
		const id = String(studentId)
		if (this.selectedStudentIds.includes(id)) {
			this.selectedStudentIds = this.selectedStudentIds.filter(
				sid => sid !== id,
			)
		} else {
			this.selectedStudentIds = [...this.selectedStudentIds, id]
		}
	}

	selectAllStudents(filteredStudents) {
		if (!Array.isArray(filteredStudents)) return

		const filteredIds = filteredStudents.map(s => String(s.id)).filter(Boolean)

		// If all filtered students are already selected, deselect them
		const allSelected =
			filteredIds.length > 0 &&
			filteredIds.every(id => this.selectedStudentIds.includes(id))

		if (allSelected) {
			// Deselect only filtered students
			this.selectedStudentIds = this.selectedStudentIds.filter(
				id => !filteredIds.includes(id),
			)
		} else {
			// Select all filtered students (add to existing selection)
			const newIds = filteredIds.filter(
				id => !this.selectedStudentIds.includes(id),
			)
			this.selectedStudentIds = [...this.selectedStudentIds, ...newIds]
		}
	}

	clearSelection() {
		this.selectedStudentIds = []
	}

	isStudentSelected(studentId) {
		if (!studentId) return false
		return this.selectedStudentIds.includes(String(studentId))
	}

	// Get count of selected students from filtered list
	getSelectedCount(filteredStudents) {
		if (!Array.isArray(filteredStudents)) return 0
		return filteredStudents.filter(s =>
			this.selectedStudentIds.includes(String(s.id)),
		).length
	}

	// Check if all filtered students are selected
	areAllFilteredSelected(filteredStudents) {
		if (!Array.isArray(filteredStudents) || filteredStudents.length === 0)
			return false
		const filteredIds = filteredStudents.map(s => String(s.id)).filter(Boolean)
		return (
			filteredIds.length > 0 &&
			filteredIds.every(id => this.selectedStudentIds.includes(id))
		)
	}

	reset() {
		this.activeFilter = 'all'
		this.selectedStudentIds = []
	}
}

export const detailsModalAssignmentStore = new DetailsModalAssignmentStore()
